<template>
  <div class="table_wrap member">
    <span class="total_length">총 {{ paginationData.total }}명 </span>
    <el-table class="list-table" header-cell-class-name="list-header"
              style="width: 100%;" height="695" empty-text="데이터가 없습니다."
              :data="memberData"
    >
      <el-table-column
              class="table_no"
              type="index"
              label="No"
              width="90"
              class-name="num text-center"
              :index="tableIdx"
      >
      </el-table-column>
      <el-table-column
              label="회원유형" width="90" class-name="text-center">
        <template slot-scope="scope">
                    <span>
                        {{returnMemberType(scope.row.mb_premium)}}
                    </span>
        </template>
      </el-table-column>
      <el-table-column
              label="큐레이터" width="90" class-name="text-center">
        <template slot-scope="scope">
                    <span>
                        {{returnCuratorType(scope.row.g_idx)}}
                    </span>
        </template>
      </el-table-column>
      <el-table-column
              label="회원상태" width="90" class-name="text-center">
        <template slot-scope="scope">
                    <span>
                        {{returnMemberStatus(scope.row.mb_is_use)}}
                    </span>
        </template>
      </el-table-column>
      <el-table-column label="아이디" width="" class-name="text-center" prop="mb_id"></el-table-column>
      <el-table-column label="닉네임" width="" class-name="text-center" prop="mb_nick"></el-table-column>
      <el-table-column label="이름" width="" class-name="text-center" prop="mb_name"></el-table-column>
      <el-table-column label="가입일" width="" class-name="text-center" prop="created_at"></el-table-column>
      <el-table-column
              label="회원상세" width="" class-name="text-center">
        <template slot-scope="scope">
          <div class="row-info ">
<!--            <div class="row-info pointer"  @click="moveDetail(scope.row.mb_no ,scope.row.g_idx)">
              [상세]
            </div>-->
              <el-button class="com_btn"  @click="moveDetail(scope.row.mb_no ,scope.row.g_idx)">
                  상세
              </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import dateMixins from "@/mixins/dateMixins";
  import util from "@/mixins/util";
  import {memberType,curatorType,memberStatus} from "@/service/memberService";
  import alertMixins from "@/mixins/alertMixins";
  export default {
    name: "MemberListDefaultLayout",
    mixins: [alertMixins],
    components: {
    },
    inject: [],
    provide() {
      return{
      }
    },
    props: {
      memberData: {default: () => []},
      paginationData: {default: {total: 0}},
    },
    data() {
      return{
        idx: 1
      }
    },
    beforeRouterEnter() {},
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {},
    computed: {
    },
    methods:{
      /*goDetail(idx) {
        this.$router.push(`/member/${idx}`);
      },
      goUpdate(idx){
        this.$router.push(`/member/curator/approve/apply/${idx}`);
      },*/
      tableIdx(index) {
        return this.paginationData.total - index - (this.paginationData.page - 1) * this.paginationData.size;
      },
      returnMemberType(type) {
        if(util.isEmpty(memberType[type])) {
          return '';
        }
        return memberType[type].name;
      },
      returnCuratorType(type) {
        if(util.isEmpty(curatorType[type])) {
          return '';
        }
        return curatorType[type].name;
      },
      returnMemberStatus(status) {
        if(util.isEmpty(memberStatus[status])) {
          return '';
        }
        return memberStatus[status].name;
      },
      moveDetail(idx,g_idx) {
          // this.$store.dispatch('memberDetail/setIsCurator', {g_idx: g_idx});
        this.$router.push(`/member/detail/${idx}`);
      },
    },
    watch: {

    },
  }
</script>

<style scoped>

</style>
